<template>
  <div class="color">
    <div class="sidenav-container">
      <!-- Sidenav for settings -->
      <div class="sidenav">
        <SettingsLayout active="UserTheme"></SettingsLayout>
      </div>
      <!-- General settings content -->
      <div
        class="sidenave-main-content"
        style="padding:0 !important;margin-top:-6px;overflow-y:hidden"
      >
        <b-row class="px-3 border-bottom">
          <b-col cols="12" class="px-0">
            <h2
              class="custom-page-title mb-2 mt-1 px-4"
              style="position:relative;bottom:4px;"
            >Navigation Theme</h2>
          </b-col>
        </b-row>
        <div
          class="sidenav-view-block py-4"
          style="padding-left:17px !important;padding-right:17px !important;overflow-y: scroll;height: calc(100vh - 92px)"
        >
          <p class="text-muted fw-semi-bold">Customize the appearence of the application sidebar</p>
          <b-row style="max-width:900px;">
            <b-col cols="12" lg="4" md="6" class="mt-2 mb-3">
              <div class="mx-auto" style="width:145px">
                <div class="select dark-turquoise"></div>

                <b-form-radio
                  v-model="theme_value"
                  value="dark-turquoise"
                  name="some-radios"
                  @change="checkTheme($event)"
                >Dark Turquoise</b-form-radio>
              </div>
            </b-col>
            <b-col cols="12" lg="4" md="6" class="mt-2 mb-3">
              <div class="mx-auto" style="width:145px">
                <div class="select microsoft-blue"></div>
                <b-form-radio
                  v-model="theme_value"
                  value="microsoft-blue"
                  name="some-radios"
                  @change="checkTheme($event)"
                >Microsoft Blue</b-form-radio>
              </div>
            </b-col>
            <b-col cols="12" lg="4" md="6" class="mt-2 mb-3">
              <div class="mx-auto" style="width:145px">
                <div class="select hoth"></div>

                <b-form-radio
                  v-model="theme_value"
                  value="hoth"
                  name="some-radios"
                  @change="checkTheme($event)"
                >Hoth</b-form-radio>
              </div>
            </b-col>
            <b-col cols="12" lg="4" md="6" class="mt-2 mb-3">
              <div class="mx-auto" style="width:145px">
                <div class="select monument"></div>
                <b-form-radio
                  v-model="theme_value"
                  value="monument"
                  name="some-radios"
                  @change="checkTheme($event)"
                >Monument</b-form-radio>
              </div>
            </b-col>

            <b-col cols="12" lg="4" md="6" class="mt-2 mb-3">
              <div class="mx-auto" style="width:145px">
                <div class="select choco-mint"></div>
                <b-form-radio
                  v-model="theme_value"
                  value="choco-mint"
                  name="some-radios"
                  @change="checkTheme($event)"
                >Choco Mint</b-form-radio>
              </div>
            </b-col>
            <b-col cols="12" lg="4" md="6" class="mt-2 mb-3">
              <div class="mx-auto" style="width:145px">
                <div class="select ochin"></div>
                <b-form-radio
                  v-model="theme_value"
                  value="ochin"
                  name="some-radios"
                  @change="checkTheme($event)"
                >Ochin</b-form-radio>
              </div>
            </b-col>

            <b-col cols="12" lg="4" md="6" class="mt-2 mb-3">
              <div class="mx-auto" style="width:145px">
                <div class="select work-hard"></div>
                <b-form-radio
                  v-model="theme_value"
                  value="work-hard"
                  name="some-radios"
                  @change="checkTheme($event)"
                >Work Hard</b-form-radio>
              </div>
            </b-col>
            <b-col cols="12" lg="4" md="6" class="mt-2 mb-3">
              <div class="mx-auto" style="width:145px">
                <div class="select nocturne"></div>
                <b-form-radio
                  v-model="theme_value"
                  value="nocturne"
                  name="some-radios"
                  @change="checkTheme($event)"
                >Nocturne</b-form-radio>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SettingsLayout from "@/components/Layout/SettingsLayout";
export default {
  components: {
    SettingsLayout
  },
  data() {
    return {
      theme_value: this.theme_name
    };
  },
  methods: {
    checkTheme(ev) {
      $("html").removeClass(this.theme_name);
      this.theme_name = ev;
      $("html").addClass(ev);
      this.$store.dispatch(
        "dashboard/updateTheme",
        JSON.stringify({
          theme: ev,
          app_id: process.env.VUE_APP_APP_ID
        })
      );
    }
  },
  created() {
    this.theme_value = this.theme_name;
  },

  computed: {
    //  to update applied credit amount in the invoice page
    theme_name: {
      get() {
        return this.$store.state.permission.theme_name;
      },
      set(val) {
        this.$store.state.permission.theme_name = val;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.select {
  font-size: 0;
  height: 65px;
  border-radius: 4px;

  margin-bottom: 8px;
}
.dark-turquoise {
  background: #05d4d7;
  border-left: 45px solid #383d49;
}

.microsoft-blue {
  background: #4e98ff;
  border-left: 45px solid #1d223d;
}
.light-slate-blue {
  background: #9374f5;
  border-left: 45px solid #413958;
}
.zambezi-brown {
  background: #caa76e;
  border-left: 45px solid #282828;
}
.bondi-blue {
  background: #428bca;
  border-left: 45px solid #2d99af;
}
.leaflet-green {
  background: #29402f;
  border-left: 45px solid #0c0f10;
}
.pacific-blue {
  background: #428bca;
  border-left: 45px solid #005689;
}
.radical-red {
  background: #fa5166;
  border-left: 45px solid #372936;
}
.cobalt-brown {
  background: #d06a42;
  border-left: 45px solid #433834;
}

// Authored by harini
.hoth {
  background: #2d9ee0;
  border-left: 45px solid #f8f8fa;
}
.monument {
  background: #f79f65;
  border-left: 45px solid #0e7e83;
}
.choco-mint {
  background: #5cb09d;
  border-left: 45px solid #544538;
}
.ochin {
  background: #6597c8;
  border-left: 45px solid #313e4d;
}
.work-hard {
  background: #d39b46;
  border-left: 45px solid #4d514f;
}
.nocturne {
  background: #0675b9;
  border-left: 45px solid #1b1d21;
}
</style>

